import { IRemoteFile, LoadStorageFileErrorType } from '../types';

export class BaseRemoteFile implements IRemoteFile {
  private privateFileData: Blob | null = null;
  private privateUrl = '';
  errorType: LoadStorageFileErrorType | null = null;

  onload: (() => void) | null = null;
  onerror: ((error: any) => void) | null = null;
  onabort: (() => void) | null = null;
  loadFile: (url: string) => Promise<void>;

  get fileData(): Blob | null {
    return this.privateFileData;
  }

  set fileData(data: Blob | null) {
    this.privateFileData = data;
  }

  set url(url: string) {
    this.privateUrl = url;
    this.loadFile(url);
  }

  get url(): string {
    return this.privateUrl;
  }
}
